import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import achievementsData from "../data/achievementsData";

export default function useStatsFetcher() {
  const [stats, setStats] = useState(
    achievementsData.map((item) => ({ ...item, value: 0 }))
  );

  useEffect(() => {
    fetchStats();
  }, []);

  async function fetchStats() {
    try {
      const { data: hoursData, error: hoursError } = await supabase.rpc(
        "get_total_volunteering_hours"
      );
      if (hoursError) throw hoursError;
      const totalHours = hoursData || 0;

      const { data: volunteersData, error: volunteersError } =
        await supabase.rpc("count_regular_users");
      if (volunteersError) throw volunteersError;
      const volunteers = volunteersData || 0;

      const { data: tasksData, error: tasksError } = await supabase.rpc(
        "count_volunteering_tasks"
      );
      if (tasksError) throw tasksError;
      const tasks = tasksData || 0;

      setStats([
        { ...achievementsData[0], value: totalHours },
        { ...achievementsData[1], value: volunteers },
        { ...achievementsData[2], value: tasks },
      ]);
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  }

  return stats;
}